<template>
  <div id="user-list-view" class="data-list-container">
    <edit-data-sidebar @event:onUpdateUserProfileResponse="onUpdateUserProfileResponse" @event:onCreateUserProfileResponse="onCreateUserProfileResponse" ref="refUserEditSidebar" :isSidebarActive="editDataSidebar" @closeSidebar="editDataSidebar = false" />

    <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="itemsPerPage" search :data="users">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN --> 
          <vs-dropdown v-show="true" vs-trigger-click class="cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="openEditUser('CREATE')">
                <span>Create User</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="openEditUser('EDIT')">
                <span>Edit User</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="openDeleteUser()">
                <span>Delete User</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }} of {{ users.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th sort-key="name">Email</vs-th>
        <vs-th sort-key="category">Roles</vs-th>
        <vs-th sort-key="order_status">Email Confirmed</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="img-container">
              <img :src="tr.photoURL" class="product-img" />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.email }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ role_choices_dict[tr.role] }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getStatusYesNoColor(tr.emailVerified)" class="product-order-status">{{ yesno_choices_dict[tr.emailVerified] }}</vs-chip>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import EditDataSidebar from './EditUserSidebar.vue';
import axios from 'axios'
import {API_BASE_URL} from '@/constants'

export default {
  components: {
    EditDataSidebar
  },
  data() {
    return {
      selected: [],
      users: [],
      itemsPerPage: 4,
      isMounted: false,
      editDataSidebar: false,
      role_choices: [
        {text:'Sys Admin',value: 'ROLE_SYSADMIN' },
        {text:'Admin',value: 'ROLE_ADMIN' },
        {text:'Editor',value: 'ROLE_EDITOR' },
        {text:'Viewer',value: 'ROLE_VIEWER' },
      ],
      role_choices_dict: {
        'ROLE_SYSADMIN': 'Sys Admin',
        'ROLE_ADMIN': 'Admin',
        'ROLE_EDITOR': 'Editor',
        'ROLE_VIEWER': 'Viewer'
      },
      yesno_choices: [
        {text:'Yes',value: true },
        {text:'No',value: false }
      ],
      yesno_choices_dict: {
        'true': 'Yes',
        'false': 'No'
      }
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  methods: {
    onCreateUserProfileResponse(data) {
      this.retrieveData();
    },
    onUpdateUserProfileResponse(data) {
      this.retrieveData();
    },
    handleSelected(tr) {
      
    },
    openEditUser(type) {

      if(type == 'CREATE') {
        this.editDataSidebar = true;
        this.$refs.refUserEditSidebar.setValues(null, type);

      } else if( this.selected.length != [] ) {
        this.editDataSidebar = true;
        this.$refs.refUserEditSidebar.setValues(this.selected, type);

      } else {
        this.$vs.notify({
          title: this.$t('Alert'),
          text: this.$t('PleaseSelectInList'),
          color:'warning',
          iconPack: 'feather',
          // position: 'top-center',
          icon:'icon-alert-circle'
        });

      }
    },
    openDeleteUser() {
      this.$vs.notify({
          title: this.$t('Alert'),
          text: this.$t('FunctionUnavailableNow'),
          color:'warning',
          iconPack: 'feather',
          // position: 'top-center',
          icon:'icon-alert-circle'
      });
    },
    getStatusYesNoColor(status) {
      return status ? "success" : "danger";
    },
    formatData(data) {
      let formattedData = data.map((item) => {
        let obj = item
        let ordered = {};
        ordered = obj.roles.sort(function(a, b) {
          return (a.id) - (b.id);
        });
        obj.role = ordered[0].name; // use a highest role
        if(obj.photoURL == null) {
          obj.photoURL = "/default_user_avatar.png";
        }
        return obj
      });
      return formattedData;
    },
    retrieveData() {
      const thisIns = this;
      this.$http.get(API_BASE_URL + 'api/users')
        .then(function (response) {
          thisIns.users = thisIns.formatData(response.data)
        })
        .catch(function (error) {
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        });
    }
  },
  created() {
    this.retrieveData();
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#user-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: center;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
